
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule} from '@angular/material/select';
import {MatRadioModule} from '@angular/material/radio';
import {MatTabsModule} from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule} from '@angular/material/menu';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule} from '@angular/material/progress-bar';
import { MatListModule} from '@angular/material/list';
import { MatExpansionModule} from '@angular/material/expansion';
import { MatChipsModule} from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatDialogModule} from '@angular/material/dialog'; 
import {MatGridListModule} from '@angular/material/grid-list'; 
import {MatPaginatorModule} from '@angular/material/paginator'; 
import {MatRippleModule} from '@angular/material/core';
import {MatSliderModule} from '@angular/material/slider'; 
import {MatSlideToggleModule} from '@angular/material/slide-toggle'; 
import {MatSortModule} from '@angular/material/sort'; 
import {MatTooltipModule} from '@angular/material/tooltip'; 
import {MatStepperModule} from '@angular/material/stepper'; 
import {MatBadgeModule} from '@angular/material/badge'; 
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    
    CommonModule,
    MatCardModule,
    MatProgressBarModule,
    MatSnackBarModule,
    MatInputModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatSelectModule,
    MatChipsModule,
    MatListModule,
    MatRadioModule,
    MatAutocompleteModule,
    MatExpansionModule,
    MatTabsModule,
    MatTableModule,
    MatDividerModule,
    MatMenuModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    MatSidenavModule,
    MatToolbarModule,

    MatButtonToggleModule,
    MatDialogModule,
    MatGridListModule,
    MatPaginatorModule,
    MatRippleModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSortModule,
    MatTooltipModule,
    MatStepperModule,
    MatBadgeModule,
    NgSelectModule,
    ReactiveFormsModule,
  ],
  exports: [
    MatInputModule,
    MatCardModule,
    MatProgressBarModule,
    MatSnackBarModule,
    MatButtonModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatIconModule,
    MatSelectModule,
    MatExpansionModule,
    MatRadioModule,
    MatTabsModule,
    MatTableModule,
    MatDividerModule,
    MatMenuModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    MatSidenavModule,
    MatToolbarModule,



    MatButtonToggleModule,
    MatDialogModule,
    MatGridListModule,
    MatPaginatorModule,
    MatRippleModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSortModule,
    MatTooltipModule,
    MatStepperModule,
    MatBadgeModule,
    NgSelectModule,
    ReactiveFormsModule
    
  ]
})
export class MaterialModule { }
